import React from 'react';
import { Box, Chip, Radio, Typography } from '@mui/material';
import { Payment as PaymentIcon } from '@mui/icons-material';
import BarionDataTransferNotice from '../Barion/BarionDataTransferNotice';
import BarionLogoStrip from '../Barion/BarionLogoStrip';

/**
 * Barion (online bankkártyás) fizetési mód a fizetési mód választókban (kosár, foglalás fizetése).
 * - enabled: a Barion be van-e kapcsolva ezen a környezeten (GET /api/payments/config)
 * - available: minden érintett szolgáltató fogad-e Barion-fizetést (ellenőrzött tárca)
 * A Barion feltételei szerint fizetés előtt tájékoztatni kell a vásárlót az adattovábbításról.
 */
const BarionPaymentOption = ({ enabled, available, selected, onSelect }) => {
  if (!enabled) {
    return (
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', px: 1.5, py: 1, mt: 1.5, opacity: 0.6 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Radio disabled />
          <Typography variant="body2">Barion (online fizetés)</Typography>
          <Chip label="Hamarosan" size="small" color="info" variant="outlined" sx={{ ml: 'auto' }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      onClick={() => available && onSelect()}
      sx={{
        border: '1px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        borderRadius: '8px',
        px: 1.5,
        py: 1,
        mt: 1.5,
        cursor: available ? 'pointer' : 'default',
        opacity: available ? 1 : 0.6,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Radio checked={selected} disabled={!available} value="BARION" />
        <PaymentIcon sx={{ color: available ? 'primary.main' : 'text.secondary' }} />
        <Typography variant="body2">Online bankkártyás fizetés (Barion)</Typography>
      </Box>
      {!available && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ml: 6 }}>
          A szolgáltató még nem fogad online fizetést.
        </Typography>
      )}
      {selected && (
        <>
          <BarionDataTransferNotice sx={{ mt: 1 }} />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
            A szolgáltatási díj a szolgáltatóhoz kerül, a platform jutaléka levonásra kerül.
          </Typography>
          <BarionLogoStrip variant="light" height={{ xs: 26, sm: 30 }} sx={{ mx: 0 }} />
        </>
      )}
    </Box>
  );
};

export default BarionPaymentOption;
